import { CheckCircle } from 'react-feather';
import styled from 'styled-components';

export const Check = styled(CheckCircle)`
	color: #00bf99;
	flex-shrink: 0;
	height: 1rem;
	width: 1rem;
`;
